import { Card, Image, Navbar } from "react-bootstrap";
import React from "react"
import Logo from "../../../assets/images/logo-footer.png"

const Footer = (): JSX.Element => {
    return (
        <Navbar
            id="rdFooter"
            expand="lg"
            fixed="bottom"
            className="fullContent verticalAlignment" >
            <Navbar.Brand className="horizontalAlignment">
                <Image src={Logo} alt="EDP Logo" fluid />&nbsp; <Card.Text>© 2023 Reuniões On-line - EDP Todos os Direitos Reservados.</Card.Text>
            </Navbar.Brand>
        </Navbar >
    );
}

export default Footer;

